import { httpGet, httpPost, httpPut, httpDelete } from "../utils/http";
import { CryptoKey } from "../utils/emunData";
import Crypto from "../utils/crypto";
import prefixPath from "../utils/prefixPath";

export default class {
  apiEndpoint = null;
  prefixPathApis = undefined;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
    this.prefixPathApis = new prefixPath(apiEndpoint);
  }

  getForm(docID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/form/${Crypto.encrypt(docID, CryptoKey)}`;
    return httpGet(apiUrl);
  }

  async getFormListByPetID(petID, clinic) {
    let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");
    let apiUrl = `${
      this.apiEndpoint
    }/api/sdk/v2/${clinicID}/form/pet/${Crypto.encrypt(petID, CryptoKey)}`;

    let res = await httpGet(apiUrl);
    if (res.code === 100000 && res.result)
      this.prefixPathApis.prependRecordResourcePath(res.result, clinicID);
    return res;
  }

  createRecordEstimateForm(data, optUserID) {
    data.optUserID = optUserID;
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/form/estimate/record`;
    return httpPost(apiUrl, data);
  }

  copyRecordEstimateForm(_id, optUserID) {
    const data = {
      optUserID,
    };

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}${_id}/copy`;
    return httpPost(apiUrl, data);
  }

  updateRecordEstimateForm(_id, data, optUserID) {
    data.optUserID = optUserID;
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}${_id}`;
    return httpPut(apiUrl, data);
  }

  deleteForm(docID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/form/${Crypto.encrypt(docID, CryptoKey)}`;
    return httpDelete(apiUrl);
  }

  uploadFormFile(docID, upload) {
    let formData = new FormData();
    Object.keys(upload).forEach((key) => {
      formData.append(key, upload[key]);
    });

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/form/${Crypto.encrypt(docID, CryptoKey)}/file`;
    return httpPost(apiUrl, formData);
  }

  deleteFormFile(docID, delFileNames) {
    delFileNames = delFileNames.map((fileName) =>
      fileName.replace(/^.*\//g, "")
    );

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/form/${Crypto.encrypt(docID, CryptoKey)}/file`;
    return httpDelete(apiUrl, delFileNames);
  }

  uploadErpFormFile(formID, upload) {
    // console.log(formID, JSON.stringify(upload));
    let formData = new FormData();
    Object.keys(upload).forEach((key) => {
      formData.append(key, upload[key]);
    });

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/form/${Crypto.encrypt(formID, CryptoKey)}/erpfile`;
    return httpPost(apiUrl, formData);
  }

  copyErpFormFile(originalID, targetID) {
    // console.log(originalID, newID));
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/form/${Crypto.encrypt(originalID, CryptoKey)}/erpcopyfiles`;
    return httpPost(apiUrl, { targetID: `${targetID}` });
  }

  deleteErpFormFile(formID, delFileNames) {
    // console.log(JSON.stringify(delFileNames));
    delFileNames = delFileNames.map((fileName) =>
      fileName.replace(/^.*\//g, "")
    );

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/form/${Crypto.encrypt(formID, CryptoKey)}/erpfile`;
    return httpDelete(apiUrl, delFileNames);
  }

  executeRecordEstimate(data, optUserID) {
    data.optUserID = optUserID;
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}${data._id}/execute`;
    return httpPut(apiUrl, data);
  }
}
